import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OrderService} from "../../../../services/OrderService";
import {CartService} from "../../../../services/CartService";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {PopoverController} from "@ionic/angular";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";

@Component({
    selector: 'app-saved-cart',
    templateUrl: './saved-cart.component.html',
    styleUrls: ['./saved-cart.component.scss']
})
export class SavedCartComponent {

    @Input()
    public onClose: any;

    @Input()
    public isPopup: boolean;

    constructor(public orderService: OrderService,
                public cartService: CartService,
                public tools:ModelToolsProvider,
                public modelProvider:ModelProvider,
                public popoberCtrl:PopoverController) {
    }

    setCart(cartData) {
        this.cartService.clearCart();
        this.cartService.updateData(cartData['data']);

        this.close()

        // this.orderService.initCart();
        // this.orderService.loadCartFromData({
        //     'cartId': cartData['cartId'],
        //     'cart': cartData['cart'],
        //     'cartData': this.orderService.cartData
        // }, false);
        // this.orderService.doCartCalc();
    }

    removeCart(cart)
    {
        let me = this;
        this.tools.yesOrNoAlert(function () {
            me.modelProvider.customPost('closeSavedCart', {'id': cart['_id']})
            cart['open'] = false;
        }, {'title':this.tools.getTranslate('removeSavedCart'), 'message': this.tools.getTranslate('areYouSure')});
    }

    close()
    {
        if(!this.isPopup) return
        this.onClose();
        this.popoberCtrl.dismiss();
    }
}
